<template>
	<c-dialog ref="dialog" width="500" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)" @resolve="editHandle">

		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
            <c-input type="hidden" name="user_type" v-model="user_type"></c-input>
			<c-form-item label="账号" required>
				<c-input name="user_name" maxlength="20" :disabled="is_manage"></c-input>
			</c-form-item>
			<c-form-item label="姓名" required>
				<c-input name="user_realname" maxlength="10" ></c-input>
			</c-form-item>
			<c-form-item label="手机号码" required>
				<c-input name="phone" maxlength="11"></c-input>
			</c-form-item>
			<c-form-item label="头像">
                <c-upload-file name="head_photo" type="image" media></c-upload-file>
			</c-form-item>

			<c-form-item label="角色"  v-show="!user_type || user_type==1" required>
				<c-select name="role_ids" async multiple @search="searchRole" :value-data="selectedRole" :disabled="editState || is_manage"></c-select>
				<template #handle>
					<c-tooltip align="end" tip="提示信息" width="260">
					    <template #tip>
							<p>角色说明：</p>
                            <p>1、系统会按照角色初始化账号权限</p>
							<p>2、如需调整用户权限，请在用户列表按PC、手机端分别设置</p>
					    </template>
					</c-tooltip>
				</template>
			</c-form-item>
			<c-form-item label="部门" required>
				<c-select name="department_id" async @search="searchDepartment" :value-data="selectedDepartment" ></c-select>
			</c-form-item>
            <c-form-item label="职级" required>
                <c-select name="position_level_id" async @search="searchPositionLevel" :value-data="selectPositionLevel" ></c-select>
            </c-form-item>
            <c-form-item label="网点">
                <c-select name="outlet_id" async @search="searchOutlet" :value-data="selectedOutlet"></c-select>
            </c-form-item>
            <c-form-item label="技能" tip="当前拥有的技能或证书信息">
                <c-select name="skills" async multiple @search="searchRequireSkills" :value-data="selectedRequireSkills"></c-select>
            </c-form-item>
            <c-form-item label="星级">
                <c-select name="star_level" :options="starLevelDic"></c-select>
            </c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="27"></custom-form>
		</c-form>
		
		<!--创建/编辑部门弹窗-->
		<department-edit ref="departmentEdit"></department-edit>
	</c-dialog>
</template>

<script>
import departmentEdit from "./department_edit.vue";
import {mapState, mapGetters} from "vuex";
export default {
	components: {
		departmentEdit
	},
	
	data() {
		return {
			editState:false,
			user_type:1,
			selectedRole:[],
			selectedDepartment:[],
            selectPositionLevel:[],
            selectedOutlet:[],
            selectedCustomer:[],
			is_manage:false,                        //是否超级管理员（1：是，2：否）
            selectedRequireSkills:[]                //关联售后服务网点定位维度
        }
	},

	computed: {
		...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'starLevelDic']),
		...mapGetters(['freeEdition']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
		async open(data) {
			this.editState = !!data;
			if (!this.editState && !(await this.checkDataCount('SYSTEM_USER')).data) return;
			this.is_manage = false;
			this.$refs.form.clear();
            this.selectedRequireSkills = [];
            this.$refs.customForm.init();
			if (data) {
				//查询部门详情
				this.request({
					url:'/sys_user/detail',
					data: {
						id:data.id
					},
					success:data => {
                        this.skills = data.detailInfo.skills;
						this.$refs.form.set(data.detailInfo);
						this.is_manage = data.detailInfo.is_manage==1?true:false;
						//已选中的[角色]
						this.selectedRole = data.roleList.map(item => {
							return {
								name:item.role_name,
								value:item.role_id
							}
						});
                        if(data.detailInfo.department_id){
                            //已选中的[部门]
                            this.selectedDepartment = [{
                                    name:data.detailInfo.department_name,
                                    value:data.detailInfo.department_id
                            }];
                        }
                        if(data.detailInfo.position_level_id){
                            this.selectPositionLevel = [{name:data.detailInfo.position_name, value:data.detailInfo.position_level_id}]
                        }
                        if(data.detailInfo.outlet_id){
                            this.selectedOutlet = [{
                                name:data.detailInfo.outlet_name,
                                value:data.detailInfo.outlet_id
                            }]
                        }
                        if(data.detailInfo.customer_id){
                            this.selectedCustomer = [{
                                name:data.detailInfo.customer_name,
                                value:data.detailInfo.customer_id
                            }]
                        }
                        if (data.detailInfo.skills){
                            this.selectedRequireSkills = data.detailInfo.skills.split(',').map(item => {
                                return {
                                    name:item,
                                    value:item
                                }
                            });
                        }
					}
				})
			}else{
				this.$refs.form.set({
					user_type: 1,
					pricing_type: 1,
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑用户' : '创建用户'
			});
		},
		/*******搜索角色*****************/
		searchRole(keyword, resolve){
			this.request({
				url:'/system/native/options',
				data: {
					options_code:'ROLE',
                    keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/department/tree_options',
				data: {
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

        /*******搜索职级*****************/
        searchPositionLevel(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'POSITION',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /*******搜索网点*****************/
        searchOutlet(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_OUTLET',
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },


        /*******搜索工程师技能*****************/
        searchRequireSkills(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code: 'DIC_INFO',
                    dic_code: 'SKILL',
                    keyword: keyword
                },
                success:data => {
                    data = data.map(item => {
                        var obj = {};
                        obj.value = item.name;
                        obj.name = item.name;
                        return obj;
                    });
                    resolve(data);
                }
            })
        },

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/sys_user/edit':'/sys_user/add',
				rule: {
					user_name: '请输账号',
					user_realname: '请输姓名',
                    phone: '请输入手机号',
					role_ids: data => {
						var flag = true;
						if(data.role_ids.length==0){
							let msg = "请选择角色";
							return msg;
						}
						return flag;
					},
                    department_id: data => {
                        var flag = true;
                        if(this.user_type == 1 && data.department_id.length==0){
                            let msg = "请选择部门";
                            return msg;
                        }
                        return flag;
                    },
                    position_level_id: data => {
                        var flag = true;
                        if(this.user_type == 1 && data.position_level_id.length==0){
                            let msg = "请选择职级";
                            return msg;
                        }
                        return flag;
                    },
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					if (this.editState){//编辑
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else {//新增
						this.$confirm({
							message: res,
							buttonName: '知道了',
							cancelButton: false,
							resolve: () => {
							}
						});

					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>